import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ICustomizationQuestion } from '../../../store/slices/customization/customization';

interface Props {
  foregroundColor: string;
  question: ICustomizationQuestion;
}

class ConceptTestStyle extends Component<Props> {
  render() {
    const { foregroundColor, question } = this.props;
    return (
      <style type="text/css" scoped>
        {`
          .page .questions .clickToContinue {
            background-color: ${foregroundColor};
          }
          .survey .page .questions .audioWrapper .playerIcon {
            color: ${foregroundColor};
          }
          .survey .page .title,
          .survey .page .title p {
            color: ${question.color};
            font-family: ${question.font};
          }
          .iconContainer:focus {
            outline: 0;
          }
          .iconContainer:focus .sx-icon {
            background-color: ${foregroundColor}90 !important;
          }
          .survey-concept-test-close:focus,
          .clickToContinue:focus {
            outline: none;
            box-shadow: 0 0 1px 6px ${foregroundColor}25;
          }
        `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const { customization } = state;
  return {
    foregroundColor: customization.foregroundColor,
    question: customization.question || {},
  };
};

export default connect(mapStateToProps)(ConceptTestStyle);
